module.exports = __webpack_public_path__ + "img/ortho.e3e13447.jpg";